import React from 'react';
import styled from 'styled-components';
import { number, string, shape, oneOf } from 'prop-types';
import { GEL_SPACING_HLF } from '@bbc/gel-foundations/spacings';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { C_RHINO, C_PEBBLE } from '@bbc/psammead-styles/colours';
import { getMinion } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { coreIcons } from '@bbc/psammead-assets/svgs';
import TimestampContainer from '@bbc/psammead-timestamp-container';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "ojp38q-0"
})(["display:flex;align-items:center;"]);
var StyledClock = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledClock",
  componentId: "ojp38q-1"
})(["display:flex;align-items:center;", " > svg{color:", ";margin:0;overflow:visible;}"], function (_ref) {
  var dir = _ref.dir;
  return dir === 'ltr' ? "padding-right: ".concat(GEL_SPACING_HLF, ";") : "padding-left: ".concat(GEL_SPACING_HLF, ";");
}, C_RHINO);

var ClockIcon = function ClockIcon(_ref2) {
  var dir = _ref2.dir;
  return /*#__PURE__*/React.createElement(StyledClock, {
    dir: dir
  }, coreIcons.clock);
};

ClockIcon.propTypes = {
  dir: oneOf(['ltr', 'rtl'])
};
ClockIcon.defaultProps = {
  dir: 'ltr'
};
var StyledTimestamp = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTimestamp",
  componentId: "ojp38q-2"
})(["display:flex;align-items:center;flex-direction:row;width:100%;> time{color:", ";", " ", "}&::after{content:'';border-top:0.0625rem solid ", ";top:", "rem;", " width:100%;}"], C_RHINO, function (_ref3) {
  var script = _ref3.script;
  return script && getMinion(script);
}, function (_ref4) {
  var service = _ref4.service;
  return service && getSansRegular(service);
}, C_PEBBLE, function (_ref5) {
  var script = _ref5.script;
  return 0.5 + script.minion.groupA.lineHeight / 2 / 16;
}, function (_ref6) {
  var dir = _ref6.dir;
  return dir === 'ltr' ? "margin-left: 0.625rem;" : "margin-right: 0.625rem;";
});
export var StartTimestamp = function StartTimestamp(_ref7) {
  var timestamp = _ref7.timestamp,
      timezone = _ref7.timezone,
      locale = _ref7.locale,
      script = _ref7.script,
      service = _ref7.service,
      dir = _ref7.dir;
  return /*#__PURE__*/React.createElement(StyledTimestamp, {
    script: script,
    service: service,
    dir: dir,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(TimestampContainer, {
    timestamp: timestamp,
    dateTimeFormat: "YYYY-MM-DD",
    format: "HH:mm",
    isRelative: false,
    padding: false,
    timezone: timezone,
    script: script,
    locale: locale,
    service: service
  }));
};
StartTimestamp.propTypes = {
  timestamp: number.isRequired,
  timezone: string,
  locale: string,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  dir: oneOf(['ltr', 'rtl'])
};
StartTimestamp.defaultProps = {
  timezone: 'Europe/London',
  locale: 'en-gb',
  dir: 'ltr'
};

var StartTime = function StartTime(_ref8) {
  var timestamp = _ref8.timestamp,
      timezone = _ref8.timezone,
      locale = _ref8.locale,
      script = _ref8.script,
      service = _ref8.service,
      dir = _ref8.dir;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ClockIcon, {
    dir: dir
  }), /*#__PURE__*/React.createElement(StartTimestamp, {
    timestamp: timestamp,
    timezone: timezone,
    locale: locale,
    script: script,
    service: service,
    dir: dir
  }));
};

StartTime.propTypes = {
  timestamp: number.isRequired,
  timezone: string,
  locale: string,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  dir: oneOf(['ltr', 'rtl'])
};
StartTime.defaultProps = {
  timezone: 'Europe/London',
  locale: 'en-gb',
  dir: 'ltr'
};
export default StartTime;